"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextualMessage_1 = require("./ContextualMessage");
exports.default = ContextualMessage_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ContextualMessage/index.js
// module id = 1765
// module chunks = 8